jQuery(document).ready(function ($) {
    $('.toggle-register-login-button').on('click', function(e) {
        $(this).closest('#customer_login').toggleClass('register-active');
    });
});
